import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const applyOrderItemAudit = createAction(
  '[Orders] Apply Order Item Audit',
  props<{ orderId: number; orderItemId: number }>(),
);

export const applyOrderItemAuditSuccess = createAction(
  '[Orders] Apply Order Item Audit Success',
  props<{ order: Order }>(),
);

export const applyOrderItemAuditFailure = createAction(
  '[Orders] Apply Order Item Audit Failure',
  props<{ error: any }>(),
);
